import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MuiTextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { createBaseStyles } from './styles';

const styles = theme => ({
  root: {
    ...createBaseStyles(theme),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  label: {
    position: 'relative',
    transform: 'none',
    marginRight: theme.spacing(1),
  },
  helperText: {
    display: 'none',
  },
});

function TextFieldLabelInline({ className, classes, ...rest }) {
  return (
    <MuiTextField
      className={classNames(classes.root, className)}
      classes={{
        root: classes.root,
      }}
      InputLabelProps={{
        className: classes.label,
      }}
      FormHelperTextProps={{
        className: classes.helperText,
      }}
      {...rest}
    />
  );
}

TextFieldLabelInline.defaultProps = {
  className: '',
};

TextFieldLabelInline.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles, { name: 'TextFieldInline' })(TextFieldLabelInline);
